var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mood-change-desc" },
    [
      _c("div", { staticClass: "title-2" }, [_vm._v("情绪变化描述")]),
      _vm.dataSource.length
        ? _c(
            "transition-group",
            {
              staticClass: "desc-list",
              staticStyle: { "margin-top": "5px" },
              attrs: { name: "list", tag: "div" },
            },
            _vm._l(_vm.dataSource, function (item) {
              return _c(
                "div",
                { key: item.text, staticClass: "desc-list-item" },
                [_vm._v("\n      " + _vm._s(item.text) + "\n    ")]
              )
            }),
            0
          )
        : _c("EmptyData", {
            attrs: { dataSource: _vm.dataSource, loading: _vm.loading },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }